import React from "react";
import {CardType} from "../../models/api/codegen/code";
//@ts-ignore
import {Charts, Gauge, History, Html, RowTemplate, Status} from "uitabs-components";
import {SwitcherChildBlocksCard} from "./SwitcherChildBlocksCard";
import {Label} from "./Label";

export const CardBody: React.FC<{ card: CardType }> = ({card}) => {

    switch (card.type) {
        case "row_template":
            return <RowTemplate card={card}/>
        case "history":
            return <History card={card}/>
        case "gauge":
            return <MemoGauge card={card} color={'#FFFFFF'}/>
        case "html":
            return <Html value={card.value}/>
        case "status":
            return <Status card={card}/>
        case "charts":
            return <Charts card={card}/>
        case "label":
            return <Label card={card}/>
        case "SWITCHER_CHILD_BLOCKS":
            return <SwitcherChildBlocksCard card={card}/>
        default:
            console.log({type: card.type})
            return <div/>
    }
}

const MemoGauge = React.memo((props: {card: CardType, color: string}) => {
    return <Gauge card={props.card} color={props.color}/>
}, propsAreEqual)

function propsAreEqual(a: Readonly<{card: CardType, color: string}>, b: Readonly<{ card: CardType, color: string }>) {
    return a.card.value === b.card.value
        && a.color === b.color
        && JSON.stringify(a.card.gauge) === JSON.stringify(b.card.gauge)
        && JSON.stringify(a.card.entityId || []) === JSON.stringify(b.card.entityId || []);
}
